export default __webpack_public_path__ + "865827d3bcce52a0e5eddce5ae8518e0.png";